import { GetBbaCropFieldsResponse } from './bba-cancellation-service.model';

export type BbaCancellationStatusFilter = 'All' | 'Cancelled' | 'Participating';

export interface BbaCropField {
  id: number;
  name: string;
  adviceId: number;
  customerId: number;
  customerName: string;
  hectares: number;
  cropId: number;
  cropName: string;
  cropVarietyId: number;
  cropVarietyName: string;
  plantDate: Date;
  orderNumber?: string;
  participationDate?: Date;
  orderDate?: Date;
  isCancelled: boolean;
  cancellationDate?: Date;
  isFertilabInformedOfCancellation: boolean;
  isAdministrationInformedOfCancellation: boolean;
}

export const mapBbaCropFieldResponse = (response: GetBbaCropFieldsResponse): BbaCropField => ({
  id: response.cropFieldId,
  name: response.cropFieldName,
  adviceId: response.adviceId,
  customerId: response.customerId,
  customerName: response.customerName,
  orderNumber: response.orderNumber,
  cropId: response.cropId,
  cropName: response.cropName,
  cropVarietyId: response.cropVarietyId,
  cropVarietyName: response.cropVarietyName,
  plantDate: new Date(response.plantDate),
  hectares: response.hectares,
  participationDate: response.participationDate ? new Date(response.participationDate) : undefined,
  orderDate: response.orderDate ? new Date(response.orderDate) : undefined,
  isCancelled: response.isCancelled,
  cancellationDate: response.cancellationDate ? new Date(response.cancellationDate) : undefined,
  isFertilabInformedOfCancellation: response.isFertilabInformedOfCancellation,
  isAdministrationInformedOfCancellation: response.isAdministrationInformedOfCancellation,
});
